import React, { SVGProps } from 'react';

const SvgAddBlueColor = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" {...props} fill="none">
            <path d="M6.54248 1.40625V13.5933" stroke="#4C80FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 7.49902H12.0848" stroke="#4C80FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg >
    );
}

export default SvgAddBlueColor;